import SnippetsAccordion from './SnippetsAccordion'

export default SnippetsAccordion
